import { render } from "./TechArea.vue?vue&type=template&id=114068c1"
import script from "./TechArea.vue?vue&type=script&lang=js"
export * from "./TechArea.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__